
import { useEffect, useState } from "react";
import api from "../api/PosApi";
import {
    Card,
    Container,
    Row,
    Col,
    Badge,
    Spinner,
    Alert
} from "react-bootstrap";

type Noticia = {
    id: number;
    titulo: string;
    descripcion: string;
    fecha: string;
    tipo: "update" | "info" | "warning" | "error" | string;
};

export default function Noticias() {
    const [noticias, setNoticias] = useState<Noticia[]>([]);
    const [cargando, setCargando] = useState(true);
    const [mensajeError, setMensajeError] = useState("");

    const cargarNoticias = async () => {
        try {
            setCargando(true);
            setMensajeError("");

            const response = await api.get("/pos/noticias");

            setNoticias(response.data);
        } catch (error) {
            console.error("Error al cargar noticias:", error);
            setMensajeError("No se pudieron cargar las noticias del sistema.");
        } finally {
            setCargando(false);
        }
    };

    const obtenerEstiloTipo = (tipo: string) => {
        switch (tipo) {
            case "update":
                return {
                    badge: "success",
                    titulo: "Actualización",
                    icono: "🚀",
                    colorBarra: "#22c55e"
                };

            case "warning":
                return {
                    badge: "warning",
                    titulo: "Aviso",
                    icono: "⚠️",
                    colorBarra: "#f59e0b"
                };

            case "error":
                return {
                    badge: "danger",
                    titulo: "Incidencia",
                    icono: "⛔",
                    colorBarra: "#ef4444"
                };

            case "info":
            default:
                return {
                    badge: "info",
                    titulo: "Información",
                    icono: "ℹ️",
                    colorBarra: "#0ea5e9"
                };
        }
    };

    useEffect(() => {
        cargarNoticias();
    }, []);

    return (
        <Container fluid className="py-4">

            {/* Bienvenida principal */}
            <Row className="mb-4">
                <Col>
                    <Card
                        style={{
                            background: "linear-gradient(135deg, #0f172a, #1e293b, #111827)",
                            color: "#fff",
                            border: "1px solid #334155",
                            borderRadius: "22px",
                            boxShadow: "0 12px 35px rgba(0,0,0,0.40)",
                            overflow: "hidden"
                        }}
                    >
                        <Card.Body className="p-4 p-md-5">
                            <Row className="align-items-center">
                                <Col lg={8}>
                                    <Badge
                                        bg="primary"
                                        className="mb-3"
                                        style={{
                                            fontSize: "0.85rem",
                                            padding: "0.55rem 0.8rem",
                                            borderRadius: "999px"
                                        }}
                                    >
                                        LogPose-SV
                                    </Badge>

                                    <h1
                                        className="mb-3"
                                        style={{
                                            fontWeight: 800,
                                            fontSize: "2.3rem",
                                            lineHeight: "1.2"
                                        }}
                                    >
                                        Bienvenido al sistema
                                    </h1>

                                    <p
                                        className="mb-4"
                                        style={{
                                            color: "#d1d5db",
                                            fontSize: "1.05rem",
                                            lineHeight: "1.7",
                                            maxWidth: "850px"
                                        }}
                                    >
                                        Desde este espacio podrás consultar las novedades del sistema,
                                        revisar actualizaciones importantes, conocer mejoras recientes
                                        y estar al tanto de avisos operativos del POS.
                                    </p>

                                    <div className="d-flex flex-wrap gap-2">
                                        <span
                                            style={{
                                                backgroundColor: "rgba(34,197,94,0.15)",
                                                color: "#86efac",
                                                border: "1px solid rgba(34,197,94,0.35)",
                                                padding: "0.55rem 0.8rem",
                                                borderRadius: "12px",
                                                fontSize: "0.9rem"
                                            }}
                                        >
                                            ✅ Actualizaciones del sistema
                                        </span>

                                        <span
                                            style={{
                                                backgroundColor: "rgba(14,165,233,0.15)",
                                                color: "#7dd3fc",
                                                border: "1px solid rgba(14,165,233,0.35)",
                                                padding: "0.55rem 0.8rem",
                                                borderRadius: "12px",
                                                fontSize: "0.9rem"
                                            }}
                                        >
                                            ℹ️ Notificaciones importantes
                                        </span>

                                        <span
                                            style={{
                                                backgroundColor: "rgba(245,158,11,0.15)",
                                                color: "#fcd34d",
                                                border: "1px solid rgba(245,158,11,0.35)",
                                                padding: "0.55rem 0.8rem",
                                                borderRadius: "12px",
                                                fontSize: "0.9rem"
                                            }}
                                        >
                                            ⚠️ Avisos operativos
                                        </span>
                                    </div>
                                </Col>

                                <Col
                                    lg={4}
                                    className="mt-4 mt-lg-0"
                                >
                                    <Card
                                        style={{
                                            backgroundColor: "rgba(15,23,42,0.75)",
                                            border: "1px solid rgba(148,163,184,0.25)",
                                            borderRadius: "18px",
                                            color: "#fff"
                                        }}
                                    >
                                        <Card.Body className="p-4">
                                            <h5
                                                className="mb-3"
                                                style={{
                                                    fontWeight: 700
                                                }}
                                            >
                                                Resumen rápido
                                            </h5>

                                            <div className="mb-3">
                                                <small style={{ color: "#94a3b8" }}>
                                                    Noticias disponibles
                                                </small>

                                                <h3 className="mb-0" style={{ fontWeight: 800 }}>
                                                    {noticias.length}
                                                </h3>
                                            </div>

                                            <div className="mb-3">
                                                <small style={{ color: "#94a3b8" }}>
                                                    Estado del panel
                                                </small>

                                                <div>
                                                    <Badge bg={mensajeError ? "danger" : "success"}>
                                                        {mensajeError ? "Con errores" : "Activo"}
                                                    </Badge>
                                                </div>
                                            </div>

                                            <button
                                                className="btn btn-outline-light w-100"
                                                onClick={cargarNoticias}
                                                disabled={cargando}
                                            >
                                                {cargando ? "Actualizando..." : "Actualizar noticias"}
                                            </button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Encabezado de noticias */}
            <Row className="mb-3">
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h3
                                className="mb-1"
                                style={{
                                    color: "#fff",
                                    fontWeight: 700
                                }}
                            >
                                Noticias y actualizaciones
                            </h3>

                            <p
                                className="mb-0"
                                style={{
                                    color: "#9ca3af"
                                }}
                            >
                                Información relevante sobre cambios, mejoras y avisos del sistema.
                            </p>
                        </div>
                    </div>
                </Col>
            </Row>

            {mensajeError && (
                <Row className="mb-3">
                    <Col>
                        <Alert variant="danger">
                            {mensajeError}
                        </Alert>
                    </Col>
                </Row>
            )}

            {cargando && (
                <Row>
                    <Col className="text-center py-5">
                        <Spinner animation="border" variant="light" />
                        <p className="mt-3 text-light">Cargando noticias...</p>
                    </Col>
                </Row>
            )}

            {!cargando && noticias.length === 0 && (
                <Row>
                    <Col>
                        <Card
                            style={{
                                backgroundColor: "#181818",
                                color: "#fff",
                                border: "1px solid #333",
                                borderRadius: "16px"
                            }}
                        >
                            <Card.Body className="text-center p-5">
                                <h4>No hay noticias disponibles</h4>
                                <p style={{ color: "#9ca3af" }}>
                                    Cuando existan actualizaciones del sistema aparecerán en este apartado.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}

            {!cargando && noticias.length > 0 && (
                <Row>
                    {noticias.map((noticia) => {
                        const estilo = obtenerEstiloTipo(noticia.tipo);

                        return (
                            <Col
                                xl={4}
                                lg={6}
                                md={12}
                                className="mb-4"
                                key={noticia.id}
                            >
                                <Card
                                    style={{
                                        height: "100%",
                                        backgroundColor: "#181818",
                                        color: "#fff",
                                        border: "1px solid #2d2d2d",
                                        borderRadius: "18px",
                                        boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
                                        overflow: "hidden"
                                    }}
                                >
                                    <div
                                        style={{
                                            height: "5px",
                                            backgroundColor: estilo.colorBarra
                                        }}
                                    />

                                    <Card.Body className="p-4">
                                        <div className="d-flex justify-content-between align-items-start mb-3">
                                            <Badge bg={estilo.badge as any}>
                                                {estilo.icono} {estilo.titulo}
                                            </Badge>

                                            {noticia.fecha && (
                                                <small style={{ color: "#9ca3af" }}>
                                                    {noticia.fecha}
                                                </small>
                                            )}
                                        </div>

                                        <h5
                                            className="mb-3"
                                            style={{
                                                fontWeight: 700,
                                                lineHeight: "1.3"
                                            }}
                                        >
                                            {noticia.titulo}
                                        </h5>

                                        <p
                                            className="mb-0"
                                            style={{
                                                color: "#d1d5db",
                                                lineHeight: "1.6",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word"
                                            }}
                                        >
                                            {noticia.descripcion}
                                        </p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            )}
        </Container>
    );
}